import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';

import { Stop, ScheduledStop } from '../core/stop';
import { Route } from '../core/route';
import { TramStop } from '../core/tram-stop';
import { RouteCollector } from './route-collector';
import { StopCollector } from './stop-collector';
import { TramCollector } from './tram-collector';
import { PanelDataExchangeService } from './panel-data-exchange.service';

@Component({
    selector: 'route-info-panel',
    templateUrl: './route-info-panel.component.html',
    styleUrls: ['./panel.scss', './route-info-panel.component.scss']
})
export class RouteInfoPanelComponent implements OnInit {
    private isShown: boolean;
    route: Route;
    stops: ScheduledStop[];
    outterStops: ScheduledStop[];

    constructor(private routeCollector: RouteCollector,
        private stopCollector: StopCollector,
        private tramCollector: TramCollector,
        private exchanger: PanelDataExchangeService) { }

    ngOnInit() {
        this.stops = [];
        this.outterStops = [];

        this.exchanger.showRouteInfoPanelHandler.on(isShown => {
            this.isShown = isShown;
        });

        this.routeCollector.afterSelect.on(data => this.onAfterSelectRoute(data));
    }

    close() {
        this.routeCollector.unselect();
        this.exchanger.showRouteInfoPanel(false);
    }

    hover(id: number, isSelected: boolean) {
        if (isSelected)
            this.stopCollector.highlight(id);
        else
            this.stopCollector.unhighlight(id);
    }

    private onAfterSelectRoute(data: any) {
        if (!this.isShown)
            return;

        let isReverse = data.isReverse;
        this.route = data.route as Route;
        let ids = isReverse ? this.route.reverseStopIds : this.route.stopIds;

        this.stops = ids.map(id => this.stopCollector.get(id)) as ScheduledStop[];
        if (this.stops.length >= 2) {
            this.outterStops = [this.stops[0], this.stops[this.stops.length - 1]];
        }
    }
}


// WEBPACK FOOTER //
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/route-info-panel.component.ts